module.exports = "https://static.cdns.space/tarot-temp/img/tarot-card.370c892f.png";